import { render, staticRenderFns } from "./detail_table_new.vue?vue&type=template&id=10ecb296&scoped=true"
import script from "./detail_table_new.vue?vue&type=script&lang=js"
export * from "./detail_table_new.vue?vue&type=script&lang=js"
import style0 from "./detail_table_new.vue?vue&type=style&index=0&id=10ecb296&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ecb296",
  null
  
)

export default component.exports